<template>
	<div class="position-relative">
		<div class="dropdown">
			<input
				type="text"
				:id="formId"
				@input="searching"
				class="custom-select"
				data-toggle="dropdown"
				aria-haspopup="true"
				aria-expanded="false"
				@focusout="ifInvalidError()"
				autocomplete="off"
				v-model="value">
			<div
				class="dropdown-menu container"
				v-if="options.length"
				aria-labelledby="dropdownMenuButton">
			    <div
			    	class="dropdown-item clickable"
			    	@mousedown="selected(option)"
			    	v-for="option in options">
			    	{{ option[arrayValue] }}
				</div>
			</div>
			<div
				class="dropdown-menu container"
				v-else
				aria-labelledby="dropdownMenuButton">
			    <div
			    	class="dropdown-item">
			    	Nenhum valor encontrado.
				</div>
			</div>
			<div
				class="invalid-feedback"
				:id="formId+'-invalid-feedback'">
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: [
			'options',
			'arrayValue',
			'formId',
			'valueDefault'
		],
		data(){
			return {
				dropdown: false,
				value: '',
				trueValue: true,
				isCalculating: false
			}
		},
        created(){
            if(this.valueDefault){
                this.value = this.valueDefault;
            }
        },
		methods: {
			ifInvalidError(){
				if(!this.value){
					this.trueValue = true;
					this.clearForm();
				}
				if(!this.trueValue){
			        var element = document.getElementById(this.formId);
			        element.classList.add("is-invalid");
			        var elementInvalid = document.getElementById(this.formId+'-invalid-feedback');
			            elementInvalid.innerHTML = "O valor é inválido";
			        this.$emit('selected', -1);
				}
			},
			selected(option){
				this.value = option[this.arrayValue];
				this.$emit('selected', option);
				this.trueValue = true;
				this.clearForm();
			},
			clearForm(){
				document.getElementById(this.formId).classList.remove("is-invalid");
			},
			searching(){
				//this.$emit('selected', 50);
				this.trueValue = false;
				for(var option of this.options){
					if(option[this.arrayValue].toLowerCase() == this.value.toLowerCase()){
						this.selected(option);
					}
				}
			},
			expensiveOperation: _.debounce(function () {
	            this.isCalculating = true
	            setTimeout(function () {
	                this.isCalculating = false
	            }.bind(this), 1000)
	        }, 500),
		},
		watch: {
	        value: function () {
	            this.expensiveOperation()
	        },
	        valueDefault: function (value) {
	            this.value = this.valueDefault
	        },
	        isCalculating: function () {
	            if(this.isCalculating){
	                this.$emit('searching', this.value);
	            }
	        },
	    }
	}
</script>

<style scoped>
	.bsh-dropdown {
		background-color: white;
		padding: 0;
		margin: 0;
	}
	.clickable {
		cursor: pointer;
	}
	.dropdown-menu{
          overflow-y:auto;
          max-height: 200px;
    }
</style>
